const STORAGE_KEY = 'jacksons.backToResults.v1';
const MOBILE_QUERY = '(max-width: 749px)';
const CONTEXT_MAX_AGE = 2 * 60 * 60 * 1000;

class BackToResultsLink extends HTMLElement {
  #mediaQuery = window.matchMedia(MOBILE_QUERY);

  connectedCallback() {
    this.anchor = this.querySelector('[data-back-to-results-link-anchor]');

    this.#mediaQuery.addEventListener('change', this.#sync);
    this.#sync();
  }

  disconnectedCallback() {
    this.#mediaQuery.removeEventListener('change', this.#sync);
  }

  #sync = () => {
    if (!(this.anchor instanceof HTMLAnchorElement)) return;

    if (!this.#mediaQuery.matches) {
      this.#hide();
      return;
    }

    const context = this.#readContext();
    if (!context) {
      this.#hide();
      return;
    }

    const label =
      context.kind === 'collection'
        ? `${this.dataset.collectionPrefix || 'Back to'} ${context.collectionTitle}`
        : this.dataset.searchLabel || 'Back to Search Results';

    this.anchor.href = context.returnUrl;
    this.anchor.querySelector('[data-back-to-results-label]').textContent = label;
    this.anchor.removeAttribute('tabindex');
    this.hidden = false;
  };

  #hide() {
    this.hidden = true;
    this.anchor?.removeAttribute('href');
    this.anchor?.setAttribute('tabindex', '-1');
  }

  #readContext() {
    try {
      const value = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
      if (!value || !['collection', 'search'].includes(value.kind)) return null;
      if (typeof value.returnUrl !== 'string' || typeof value.productPath !== 'string') return null;
      if (!Number.isFinite(value.capturedAt) || Date.now() - value.capturedAt > CONTEXT_MAX_AGE) return null;
      if (value.productPath !== window.location.pathname) return null;
      if (value.kind === 'collection' && !value.collectionTitle) return null;

      const url = new URL(value.returnUrl, window.location.origin);
      const validPath =
        value.kind === 'collection' ? url.pathname.startsWith('/collections/') : url.pathname === '/search';

      if (url.origin !== window.location.origin || !validPath) return null;

      return {
        ...value,
        returnUrl: `${url.pathname}${url.search}${url.hash}`,
      };
    } catch {
      return null;
    }
  }
}

if (!customElements.get('back-to-results-link')) {
  customElements.define('back-to-results-link', BackToResultsLink);
}
